// 0_global/scrollbar_size.js
// Measures the OS scrollbar width once at load and exposes it on
// window.NAT.scrollbarWidth, so layout code can offset for it. Falls back to 6px
// if the viewport reports no difference (e.g. overlay scrollbars).

window.NAT = window.NAT || {};

const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth || 6;

window.NAT.scrollbarWidth = scrollbarWidth;
